/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Transcription_ServiceInputs */



/**
* | output |
* | --- |
* | "Select the transcription service to use" |
*
* @param {Select_Transcription_ServiceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_transcription_service = /** @type {((inputs?: Select_Transcription_ServiceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Transcription_ServiceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez le service de transcription à utiliser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie den zu verwendenden Transkriptionsdienst aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il servizio di trascrizione da utilizzare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите услугу транскрипции для использования.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el servicio de transcripción que desea utilizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要使用的转录服务。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("使用する文字起こしサービスを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोग करने के लिए ट्रांसक्रिप्शन सेवा का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o serviço de transcrição que deseja usar.")
	return /** @type {LocalizedString} */ ("Select the transcription service to use")
});